import { render, staticRenderFns } from "./MomentToMomentRatings.story.vue?vue&type=template&id=779d826b&"
import script from "./MomentToMomentRatings.story.vue?vue&type=script&lang=ts&"
export * from "./MomentToMomentRatings.story.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports